/**
 * Swippable
 */
import {Swiper} from "../types/Swipe";
import {Component} from "../Component";

export function onSwipe(selector: Component, component?: Component): Swiper {
    return new Swiper(selector, component ? component : selector);
}